<template>
  <div :class="$style.box">
    <Summary
      :model="activityInfo"
      :class="$style.content"
      @close="close"
      @showBind="showBind"
      @showRealName="showRealName"
      @redirectFloatPage="redirectFloatPage"
      v-if="activityInfo && activity_type === 1 && !giftVisible"
      :isH5="true"
      @showGift="showGift"
    ></Summary>
    <div v-if="activity_type === 0 && !giftVisible">
      <FlashPage
        :class="$style.page"
        v-for="(item, index) in pages"
        v-show="index === currentIndex"
        :key="index"
        :page="item"
        :inputShow="index === currentIndex"
        @closePage="closePage(index)"
        @redirectFloatPage="redirectFloatPage"
        @showBind="showBind"
        @showRealName="showRealName"
        @showGift="showGift(item)"
      ></FlashPage>
    </div>
    <!-- 绑定手机组件 -->
    <div :class="$style.bind" v-if="bindVisible">
      <Bind @back="closeBind" :fullScreenFlag="true"></Bind>
    </div>
    <div :class="$style.bindMask" v-if="giftVisible">
      <Gift @close="closeGift" :giftId="giftId" :giftType="giftType"></Gift>
    </div>
  </div>
</template>

<script>
import FlashPage from '@/components/activity/FlashPage';
import Bind from '@/components/login/BindPhone'
import Summary from '@/components/activity/Summary';
import Gift from '@/components/activity/Gift.vue'
import { mapState, mapActions, mapMutations } from 'vuex';
import { getStorage } from '@/libs/utils';

export default {
  components: {
    FlashPage,
    Summary,
    Gift,
    Bind
  },
  data() {
    return {
      currentIndex: 0,
      storeIndex: -1, // 当点击绑定手机时，暂时存储当前的页面index
      startTime: '',
      bindVisible: false,
      giftVisible: false,
      giftId: "",
      giftType: ""
    };
  },
  watch: {
    pages(newQuestion, oldQuestion) {
      const id = newQuestion[0].flash_id;
      this.setFlashCatChe(id);
    },
    activity_type() {
      this.getActivityData();
    }
  },
  mounted() {
    this.startTime = new Date().getTime();
    this.getActivityData();
  },
  computed: {
    ...mapState({
      pages: state => state.activity.flash_info,
      roleInfo: state => state.activity.role_info,
      userInfo: state => state.user,
      activityInfo: state => state.activity.activity_info,
      activityShowInfo: state => state.activity.activity_show_info,
      activity_type: state => state.activity.activity_type
    })
  },
  methods: {
    ...mapMutations({
      changeUserState: 'user/CHANGE_STATE',
      changeActivityState: 'activity/CHANGE_STATE'
    }),
    ...mapActions({
      report: 'activity/report',
      getFlashInfo: 'activity/getFlashInfo',
      getActivityInfo: 'activity/getActivityInfo'
    }),
    closeGift() {
      this.giftVisible = false;
    },
    showGift(item) {
      if (!item.gift_id) return;
      this.giftId = item.gift_id;
      this.giftType = 3
      setTimeout(() => {
        this.giftVisible = true;
      }, 1500);
    },
    // 缓存展示过的闪页od
    setFlashCatChe(id) {
      let flashIdList = localStorage.getItem('flashIdList') || '1,2';
      flashIdList = flashIdList ? flashIdList.split(',') : [];
      flashIdList.push(id);
      flashIdList = [...new Set(flashIdList)];
      localStorage.setItem('flashIdList', flashIdList.join(','));
    },
    // 获取活动列表
    getActivityData() {
      if (this.activity_type === 0) {
        const flashIdList = localStorage.getItem('flashIdList') || '';
        this.getFlashInfo({
          appkey: this.userInfo.appkey,
          user_id: this.userInfo.user_id,
          server_created_at: this.roleInfo.serverCreatedAt,
          level: this.roleInfo.roleLevel,
          role_id: this.roleInfo.roleId,
          show_flash_id: flashIdList
        });
      } else {
        this.getActivityInfo({
          appkey: this.userInfo.appkey,
          user_id: this.userInfo.user_id,
          server_created_at: this.roleInfo.serverCreatedAt,
          level: this.roleInfo.roleLevel,
          role_id: this.roleInfo.roleId
        });
      }
    },
    async closeBind(bindSuccess) {
      this.bindVisible = false;
      if (bindSuccess) {
        this.giftType = 1
        this.giftVisible = true;
      }
    },
    redirectFloatPage(page) {
      this.changeActivityState({ 
        activity_show_info: {
          ...this.activityShowInfo,
          visible: false
        } 
      })
      this.$store.commit('user/CHANGE_STATE', { floatWindowVisible: true });
      setTimeout(() => {
        const tabs = this.$store.state.suspend.tabs;
        const activeTab = tabs.find(item => item.type == page);
        if (activeTab && activeTab.show == true) {
          this.$store.commit('suspend/CHANGE_STATE', { activeTab });
        }
      }, 500)
    },
    close() {
      this.changeActivityState({ 
        activity_show_info: {
          ...this.activityShowInfo,
          visible: false
        } 
      })
      this.$store.commit('user/CHANGE_STATE', { floatWindowVisible: true });
    },
    async closePage(index) {
      if (!this.pages.length) {
        return;
      }
      const currentTime = new Date().getTime();
      const time = parseInt((currentTime - this.startTime) / 1000);
      const appkey = getStorage('appkey');
      const data = {
        user_id: this.userInfo.user_id,
        flash_id: this.pages[index].flash_id,
        flash_time: time,
        type: 'flash',
        appkey
      };
      await this.report(data);
      this.startTime = currentTime;
      if (index === this.pages.length - 1) {
        this.changeActivityState({ 
          activity_show_info: {
            ...this.activityShowInfo,
            visible: false
          } 
        })
      } else {
        this.currentIndex = index + 1;
        const id = this.pages[index + 1].flash_id;
        this.setFlashCatChe(id);
      }
    },
    async showBind() {
      const telStatus = getStorage('tel_status');
      if (telStatus == 1) {
        this.$toast('当前账号已绑定手机');
        this.giftType = 1
        this.giftVisible = true;
        return;
      }

      this.bindVisible = true;
    },
    backToFlash() {
      this.bindShow = false;
      this.maskVisible = false;
    },
    showRealName() {
      this.$emit('realname');
    },
    closeRealName() {
      this.realNameVisible = false;
      this.maskVisible = false;
    }
  }
};
</script>

<style lang="scss" module>
.box {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  .page {
    position: absolute;
    left: 0;
    top: 0;
  }
  .content {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 535px;
    height: 313px;
    margin: auto;
    @media screen and (orientation: portrait) {
      width: 354px;
      height: 275px;
    }
  }
  .bindMask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 102;
  }
}
</style>